<script>
  // @ts-check
  import SearchResultListItem from "../SearchResultList/SearchResultListItem.svelte";
  import Rule from "../../atoms/Rule.svelte";
  import { getTheme } from "../../utilities/themes.js";
  import SearchResultAd from "./SearchResultAd.svelte";

  /** Primarily used for testing @type {string} */
  export let id = undefined;

  /** Title @type {string} */
  export let title = undefined;

  /** @typedef {Object} Link
   * @property {string} url
   * @property {string[] | undefined} tags
   * @property {string} headline
   * @property {string} subCopy
   * @property {string  | null} imageSrc
   * @property {string | null} srcset
   * @property {string | null} sizes
   */

  /**  An array of links to display in the search results list
   *  @type {Link[]}
   * */
  export let links;

  /** The type of layout variant to render
   * @type { "default" | "small" }
   */
  export let layoutVariant = "default";

  /**
   * The theme of the hero section
   * @type {import('../../utilities/themes.js').ThemeName}
   */
  export let theme = "lightGrey";
  let currentTheme = getTheme(theme);

  /**
   * An optional CSS class to be applied to the component.
   * @type {string}
   */
  export let componentClass = "";

  const linksContainAd = links.some((link) => link.shouldDisplayAd);

  const containerClass = {
    default: "my-7.5",
    small: "my-5 xl:my-7.5"
  };
</script>

<div {id} class="{componentClass} {currentTheme.backgroundColor}">
  {#if title}
    <h3 class="label pb-5 text-dark-grey">{title}</h3>
    <Rule type="thin" theme="white" />
  {/if}
  <ul class="flex flex-col">
    {#each links as link, index (index)}
      {@const shouldNotRenderHorizontalRule =
        (index === 1 && linksContainAd) || link.shouldDisplayAd || index === links.length - 1}
      <li class="group/li contents">
        {#if link.shouldDisplayAd}
          <SearchResultAd {link} />
        {:else}
          <SearchResultListItem
            theme={currentTheme}
            {link}
            {layoutVariant}
            containerClass={containerClass[layoutVariant]}
            isLastItem={index === links.length - 1}
          />
        {/if}
        {#if !shouldNotRenderHorizontalRule}
          <Rule type="thin" theme="white" />
        {/if}
      </li>
    {/each}
  </ul>

  <slot name="button" />
</div>
